<template>
  <div id="discounts">
    <div class="bac">
      <div class="left">
        <div class="lefttitle">优惠活动</div>
        <div class="lefttContentBac">
          <div :class="selectLeftIndex == 0 ? 'leftSelect':'leftDefault'">全部优惠</div>
          <!-- <div :class="selectLeftIndex == 1 ? 'leftSelect':'leftDefault'">全部优惠1</div> -->
        </div>
      </div>
      <div class="right">
        <ul>
          <li v-for="(discount,index) in discountArr" :key="index">
            <img
              :src="$common.getImgUrl(discount.picture)"
              class="rightImg"
              @click="toActDetail(discount)"
            />
            <div v-if="discount.id == selectIndex" style="background-color: #FFF">
              <div class="discountBox">
                <div class="title">
                  <h2>{{boxData.name}}</h2>
                  <p>
                    时间：
                    <label v-if="boxData.forever==1">长期</label>
                    <label
                      v-if="boxData.forever==0&&boxData.type == 0"
                    >{{$utils.getTime(boxData.validStartTime)+' 至 '+$utils.getTime(boxData.validEndTime)}}</label>
                    <label
                      v-if="boxData.forever==0&&boxData.type != 0"
                    >{{$utils.getTime(boxData.startTime)+' 至 '+$utils.getTime(boxData.endTime)}}</label>
                  </p>
                </div>
                <div class="count" v-if="boxData.rules" v-html="boxData.rules"></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectIndex: -1,
      selectLeftIndex: 0,
      discountArr: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1, //list总页数
      isLoading: true,
      isList: true,
      boxData: {},
      userId: "",
      userName: "",
      tenetid: "",
    };
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.id) {
      this.getActDetail(this.$route.query.id);
    }
  },
  mounted() {
    this.getActivityData();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (
        window.pageYOffset >
          document.body.offsetHeight - window.innerHeight - 300 &&
        this.isLoading &&
        this.isList
      ) {
        if (this.currentPage < this.totalPages) {
          this.isLoading = false;
          this.currentPage++;
          this.getActivityData();
        }
      }
    },
    async getActivityData(currentPage = 1, pageSize = 12) {
      var _obj = { currentPage: this.currentPage, pageSize: this.pageSize };
      var res = await this.$http.post(this.$api.activity, _obj);
      this.isLoading = true;
      if (res.code == 0) {
        this.totalPages = res.data.totalPages;
        if (res.data.content.length) {
          this.discountArr.push(...res.data.content);
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    toActDetail(item){
      //type=3,url有值，跳转；url为空，打开详情
      if (item.type == 3) {
        if (item.activityExtensionsVo.url) {
          //跳转链接
          window.open(item.activityExtensionsVo.url);
          return;
        }else if(item.activityExtensionsVo && item.activityExtensionsVo.type == 4){  //跳转游戏
					if(!this.$common.getUser()){
             this.$message.error('请先进行登录');
					 return;
					}else{
						this.userId = this.$common.getUser().user_id;
						this.userName = this.$common.getUser().username;
						this.tenetid = this.$common.getUser().tenant_id;
						this.getToken(item.activityExtensionsVo.activityGame,1)
            return;
					}
				} else {
          //打开活动详情
        var id = item.id;
        }
      } else {
        var id = item.id;
      }
      this.getActDetail(id);
    },
       // 进入游戏
    getToken: async function(req,index) {
    // console.log('检测游戏信息',req)
    // return
        let self = this;
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
            
        if (!self.$common.getUser()) {
            console.log('还未登录')
            // self.showLogin = true;
            self.$message.warning('请登录')
            return
        }
        // console.log('123')
        self.tenantId = self.$common.getUser().tenant_id
        self.username = self.$common.getUser().username
        self.uid = self.$common.getUser().user_id
        let datas = {
            tenantId: self.tenantId,
            username: self.username,
            gameId: index == 2?req.ids:req.id,
            clientIp: self.$config.clientIp,
            memberId: self.uid,
            terminalType: 1
        }
        self.$common.setGameRequestData(datas)
        
        const res = await self.$http.post(this.$api.getToken, datas, true)
        if (res.code == 0) {
            self.gameUrl = res.data;
            if (req.openMode === 1) {
            // if(issafariBrowser) {
                //  self.winOpen.location.href = self.gameUrl;
            // }else{
                window.open(self.gameUrl)
            // }
            
            }else{
                window.open(self.gameUrl)
            }

        } else {
            if (req.openMode === 1) {
            window.open('/error.html?type=1')
            // self.winOpen.location.href = '/error.html?type=1';
            }
            
            if (req.status === 0) {
            self.$message.error('维护中')
            }else{
            self.$message.error('进入游戏失败，请稍后重试！')
            }
        }
    },
    async getActDetail(_id) {
      if (_id == this.selectIndex) {
        this.selectIndex = -1;
        this.boxData = [];
        this.isList = true;
        return;
      }

      this.selectIndex = _id;
      var res = await this.$http.get(this.$api.activityInfo, _id, true);
      if (res.code == 0) {
        this.boxData = res.data;
        this.isList = false;
      } else {
        this.$message.error(res.msg);
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.bac {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  flex-direction: row;
  padding: 10px;
}
.left {
  width: 200px;
  height: 100%;
  background-color: #fff;
}
.lefttitle {
  height: 40px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #f5f5f5;
}
.lefttContentBac {
  cursor: pointer;
}
.leftSelect {
  color: #f43b5b;
  height: 38px;
  line-height: 38px;
  padding: 0 20px;
  font-size: 14px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}
.leftDefault {
  color: #666;
  height: 38px;
  line-height: 38px;
  padding: 0 20px;
  font-size: 14px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}
.leftSelect:hover {
  background-color: #e5d4d1;
}
.leftDefault :hover {
  background-color: #e5d4d1;
}
.right {
  margin-left: 10px;
  width: 1000px;
}
.rightImg {
  width: 100%;
  height: 376px;
  margin-bottom: 10px;
  cursor: pointer;
  border: 1px solid #ece0df;
}

.discountBox {
  background: #fff;
  padding: 20px;
  .title {
    position: relative;
    span {
      position: absolute;
      top: 40px;
      left: 40px;
      font-size: 16px;
      cursor: pointer;
    }
    h2 {
      font-size: 24px;
      font-weight: 200;
      line-height: 40px;
    }
    p {
      font-size: 14px;
      color: #aaa;
    }
  }
  .count {
    margin-top: 10px;
  }
}
</style>
